import { render, staticRenderFns } from "./UcCompanyBankAccountFieldset.yaml?vue&type=template&id=4876ca9c&component"
import script from "./UcCompanyBankAccountFieldset.yaml?vue&type=script&lang=ts&component"
export * from "./UcCompanyBankAccountFieldset.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports